<template>
    <ul class="flex-shrink-0 flex space-x-1">
        <li
            v-for="(color, index) in colors"
            :key="index"
            class="h-6 w-6 border ct-border-1 rounded-sm"
            :style="{ 'background-color': hexToRgba(color), opacity: color ? 1 : 0 }"
        ></li>
    </ul>
</template>

<script>
import { hexToRgba } from "@/shared/utils/helpers";

export default {
    name: "cThemes",
    props: {
        colors: Array,
    },
    methods: {
        hexToRgba,
    },
};
</script>
